module.exports = __webpack_public_path__ + "static/okanlawon-edcfdfd43d52380316dc186a9734b31a.png";